<template>
    <div 
        class="filer-control-dropdown"
        :class="{'filer-control-dropdown__menu_active': isShowMenu}"
    >
        <button
            class="filer-control-dropdown__btn"
            :class="{'filer-control-dropdown__btn_active': isShowMenu}"
            :style="{width: width, height: height}"
            @click="toggleMenu"
        >
            <div>
                <div class="filer-control-dropdown__btn-title">{{title}}</div>
                <div 
                    class="filer-control-dropdown__btn-content"
                    :class="{'filer-control-dropdown__btn-content_empty': selectedItemsBuffer.length === 0}"
                >
                    {{selectedItemsName}}
                </div>
            </div>
            <div 
                class="filer-control-dropdown__btn-caret"
                :class="{'filer-control-dropdown__btn-caret_active': isShowMenu}"
            >
                <i class="icon-chevron-down" />
                <!-- <i
                    class="fa"
                    :class="{'fa-angle-down': isShowMenu, 'fa-angle-up': !isShowMenu}"
                    :style="{'margin-left': `50px`, 'color': `#a7b0bd`}"
                >
                </i> -->
            </div>
        </button>
        <transition name="slide-fade">
        <div
            v-show="isShowMenu"
            class="filer-control-dropdown__menu"
            :style="{width: width}"
        >
            <div
                v-if="isSearch"
                class="filer-control-dropdown__menu-input-search"
            >
                <input-search v-model="searchString" @input="onSearch"/>
            </div>
            <button
                v-if="isManyItems && Object.keys(itemsBuffer).length !== 0"
                class="filer-control-dropdown__menu-item-all"
                @click="onSelectAll"
            >
                {{(selectedItemsBuffer.length === Object.keys(itemsBuffer).length) ? "Убрать все" : "Выбрать все"}}
            </button>
            <div class="filer-control-dropdown__menu-container">
                <div v-if="searchString !== '' && Object.keys(itemsBuffer).length === 0">
                    Ничего не найдено
                </div>
                <button
                    v-for="(itemKey, index) in Object.keys(itemsBuffer)"
                    :key="index"
                    class="filer-control-dropdown__menu-item"
                    :class="{'filer-control-dropdown__menu-item_active': selectedItemsBuffer.includes(itemKey)}"
                    @click="onSelect(itemKey)"
                >
                    <span>
                        {{itemsBuffer[itemKey]}}
                    </span>
                    <i
                        v-if="selectedItemsBuffer.includes(itemKey)"
                        class="filer-control-dropdown__menu-item-icon icon-success"
                    >
                    </i>
                </button>
            </div>
            <div class="filer-control-dropdown__menu-action-btn-container">
                <button 
                    class="filer-control-dropdown__menu-action-btn_cancel"
                    @click="hideMenu"
                >
                    Отмена
                </button>
                <button 
                    class="filer-control-dropdown__menu-action-btn_apply"
                    @click="onChange"
                >
                    Ок
                </button>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
import InputSearch from './InputSearch';
export default {
    name: 'Dropdown',
    components: {
        InputSearch
    },
    /**
     * Входные данные компонента
     * @property {string} title - заголовок
     * @property {object} items - элементы меню
     * @property {array} selectedItems - выбранные элементы
     * @property {boolean} isManyItems - условие для множественного выбора
     * @property {boolean} isSearch - условие отображения строки поиска
     * @property {string} width - ширина
     * @property {string} height - высота
     */
    props: {
        title: {
            type: String,
            default: ''
        },
        prompt: {
            type: String,
            default: 'Выберите значение'
        },
        items: {
            type: Object,
            default: () => ({})
        },
        selectedItems: {
            type: Array,
            default: () => ([])
        },
        isManyItems: {
            type: Boolean,
            default: false
        },
        isSearch: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '220px'
        },
        height: {
            type: String,
            default: '44px'
        }
    },
    /**
     * Данные компонента
     * @property {boolean} isShowMenu - условие показа меню дропдауна
     * @property {object} itemsBuffer - элементы списка
     * @property {array} selectedItemsBuffer - буффер выбранных значений
     * @property {string} searchString - строка поиска
     */
    data: () => ({
        isShowMenu: false,
        itemsBuffer: {},
        selectedItemsBuffer: [],
        searchString: ''
    }),
    computed: {
        /**
         * имя выбранных элементов
         * @returns {string}
         */
        selectedItemsName() {
            let name = "";
            switch (this.selectedItemsBuffer.length) {
                case 0: {
                    name = this.prompt;
                    break;
                }
                case 1: {
                    name = this.prompt;
                    if(typeof this.itemsBuffer[this.selectedItemsBuffer[0]] !== 'undefined'){
                        name = this.itemsBuffer[this.selectedItemsBuffer[0]];
                    }
                    break;
                }
                default: {
                    var tmpCount = 0;
                    for (var i = 0; i < this.selectedItemsBuffer.length; i++){
                        if(!name && typeof this.itemsBuffer[this.selectedItemsBuffer[i]] !== 'undefined'){
                            name = this.itemsBuffer[this.selectedItemsBuffer[i]];
                        }
                        if(typeof this.itemsBuffer[this.selectedItemsBuffer[i]] !== 'undefined'){
                            tmpCount++;
                        }
                    }
                    if(!tmpCount){
                        name = this.prompt;
                    }
                    if (tmpCount > 1){
                        name += ' и еще ' + (tmpCount - 1);
                    }
                    // name = `${this.itemsBuffer[this.selectedItemsBuffer[0]]} и еще ${this.selectedItemsBuffer.length - 1}`;
                    break;
                }
            }
            return name;
        }
    },
    watch: {
        /**
         * если изменился список элементов - перезаписываем буфер и очищаем строку поиска
         */
        items: function() {
            this.itemsBuffer = Object.assign({}, this.items);
            this.searchString = ''
        },
        /**
         * если изменились выбранные данные - перезаписываем буфер
         */
        selectedItems: function() {
            this.selectedItemsBuffer = this.selectedItems.slice();
        }
    },
    mounted() {
        // переносим список элементов в буфферный массив
        this.itemsBuffer = Object.assign({}, this.items);
        // очищаем строку поиска
        this.searchString = ''
        // переносим выбранные значения в буфферный массив
        this.selectedItemsBuffer = this.selectedItems.slice();
    },
    methods: {
        /**
         * переключить отображение меню
         */
        toggleMenu() {
            if (this.isShowMenu)
                this.hideMenu();
            else
                this.showMenu();
        },
        /**
         * показать меню
         */
        showMenu() {
            this.isShowMenu = true;
            document.addEventListener('click', this.clickOutSide);
        },
        /**
         * скрыть меню
         */
        hideMenu() {
            this.isShowMenu = false;
            this.selectedItemsBuffer = this.selectedItems.slice();
            document.removeEventListener('click', this.clickOutSide);
        },
        /**
         * слушаем зарегестрированное событие на dom
         * проверяем клик вне элемента
         * @param {object} event - объект события
         */
        clickOutSide(event) {
            let element = event.target;
            if (!this.$el.contains(element))
               this.hideMenu(); 
        },
        /**
         * событие выбрать все / убрать все
         */
        onSelectAll() {
            let isSelectAll = this.selectedItemsBuffer.length < Object.keys(this.itemsBuffer).length;
            if (isSelectAll) {
                let itemsKey = Object.keys(this.itemsBuffer);
                itemsKey.forEach(key => {
                    if (!this.selectedItemsBuffer.includes(key)) {
                       this.selectedItemsBuffer.push(key); 
                    }
                });   
            }
            else {
                this.selectedItemsBuffer = [];
            }
        },
        /**
         * событие выбора элемента
         * @param {string} itemKey - ключ элемента
         */
        onSelect(itemKey) {
            if (this.isManyItems)
                this.onSelectManyItems(itemKey);
            else
                this.onSelectItem(itemKey);
        },
        /**
         * событие выбора элемента без множественного выбора
         * @param {string} itemKey - ключ элемента
         */
        onSelectItem(itemKey) {
            let isActiveItem = this.selectedItemsBuffer.includes(itemKey);
            if (!isActiveItem) {
               this.selectedItemsBuffer.splice(0, 1, itemKey); 
            }
        },
        /**
         * событие выбора элемента при множественном выборе
         * @param {string} itemKey - ключ элемента
         */
        onSelectManyItems(itemKey) {
            let isActiveItem = this.selectedItemsBuffer.includes(itemKey);
            if (isActiveItem) {
                let indexActiveItem = this.selectedItemsBuffer.findIndex((item) => {
                    return item === itemKey;
                });
                this.selectedItemsBuffer.splice(indexActiveItem, 1);
            }
            else {
                this.selectedItemsBuffer.push(itemKey);
            }
        },
        /**
         * сохранить изменения
         */
        onChange() {
            let isEqual = this.isEqual(this.selectedItems.slice(), this.selectedItemsBuffer.slice());
            if (!isEqual) {
                this.$emit('onChange', this.selectedItemsBuffer);
            }
            this.hideMenu();
        },
        /**
         * проверка эквивалентности массивов
         * @param {array} arr1 - массив
         * @param {array} arr2 - массив
         * @returns {boolean}
         */
        isEqual(arr1, arr2) {
            arr1.sort();
            arr2.sort();
            let isEqualLength = arr1.length == arr2.length;
            let isEqualValues = arr1.every((value, index) => value === arr2[index]);
            return isEqualLength && isEqualValues;
        },
        /**
         * событие изменения строка поиска
         * @param {string} value - строка поиска
         */
        onSearch() {
            let pattern = this.searchString
            let itemsFiltered = Object.fromEntries(Object.entries(this.items).filter(item => String(item[1]).toLowerCase().includes(pattern.toLowerCase())));
            this.itemsBuffer = itemsFiltered;
        }
    }
}
</script>

<style lang="scss" scoped>
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.2s ease;
    }
    .slide-fade-enter {
        transform: translateY(-20px);
        opacity: 0;
    }
    .slide-fade-leave-to {
        transform: translateY(-20px);
        opacity: 0;
    }
    .filer-control-dropdown__btn {
        display: flex;
        flex-direction: column;
        margin: 0 10px 13px 0;
        cursor: pointer;
        padding: 5px 10px;
        background: #f1f3f5;
        border-radius: 4px;
        border: 1px solid transparent;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .filer-control-dropdown__btn:hover {
        transition: .3s;
        border-color: #fe1060;
    }
    .filer-control-dropdown__btn_active {
        border-color: #fe1060;
    }
    .filer-control-dropdown__btn:focus {
        outline: 0;
    }
    .filer-control-dropdown__btn-title {
        font-size: 0.8rem;
        color: #b0b1b4;
        text-align: left;
    }
    .filer-control-dropdown__btn-content {
        white-space: nowrap;
    }
    .filer-control-dropdown__btn-content_empty {
        color: #b0b1b4;
    }
    .filer-control-dropdown__btn-caret {
        transition: .3s;
        margin-left: 7px;
        font-size: .3846rem;
    }
    .filer-control-dropdown__btn-caret_active {
        transform: rotate(-180deg);
    }
    .filer-control-dropdown__menu {
        background: #fff;
        position: absolute;
        pointer-events: none;
        min-width: 150px;
        box-shadow: 7px 5px 20px rgba(34,44,54,.15);
        border-radius: 5px;
        z-index: 9;
        display: flex;
        flex-direction: column;
        pointer-events: auto;
    }
    .filer-control-dropdown__menu::before {
        content: "";
        position: absolute;
        display: block;
        border: 9px solid transparent;
        border-bottom-color: #fff;
        z-index: 999;
        left: calc(50% - 10px);
        top: -18px;
    }
    .filer-control-dropdown__menu-container {
        max-height: 360px;
        overflow-y: auto;
        padding: 0 20px;
        max-height: 200px;
        overflow: auto;
        margin-bottom: 20px
    }
    .filer-control-dropdown__menu-input-search {
        padding: 10px 20px;
    }
    .filer-control-dropdown__menu-item-all {
        position: relative;
        display: flex;
        white-space: nowrap;
        line-height: 1;
        align-items: center;
        color: #222;
        transition: all 150ms;
        cursor: pointer;
        border: 0;
        background: none;
        text-align: left;
        overflow: visible;
        font: inherit;
        outline: 0;
        width: 100%;
        text-overflow: ellipsis;
        padding: 0 0 0 0;
        padding: 0 20px 0 20px;
    }
    .filer-control-dropdown__menu-item {
        position: relative;
        display: flex;
        white-space: nowrap;
        line-height: 1;
        align-items: center;
        color: #222;
        transition: all 150ms;
        cursor: pointer;
        border: 0;
        background: none;
        text-align: left;
        overflow: visible;
        font: inherit;
        margin: 10px 0 0 0;
        outline: 0;
        width: 100%;
        text-overflow: ellipsis;
        padding: 0 0 0 0;
        justify-content: space-between;
    }
    .filer-control-dropdown__menu-item:hover {
        color: #fe1060;
    }
    .filer-control-dropdown__menu-item_active {
        color: #fe1060;
    }
    .filer-control-dropdown__menu-item-icon {
        color: #fe1060;
        font-size: .6154rem;
    }
    .filer-control-dropdown__menu-action-btn-container {
        display: flex;
        justify-content: flex-end;
        padding: 10px 20px;
        pointer-events: auto;
    }
    %filer-control-dropdown__menu-action-btn {
        cursor: pointer;
        pointer-events: auto;
        height: 32px;
        width: min-content;
        padding: 4px 14px;
        border-radius: 100px;
        transition: .3s;
        border: 1px solid transparent;
        outline: none;
    }
    .filer-control-dropdown__menu-action-btn_cancel {
        @extend %filer-control-dropdown__menu-action-btn;
        color: #9b9b9b;
    }
    .filer-control-dropdown__menu-action-btn_cancel:hover {
        color: #fe1060;
        border-color: #fe1060;
    }
    .filer-control-dropdown__menu-action-btn_apply {
        @extend %filer-control-dropdown__menu-action-btn;
        margin-left: 5px;
        color: #000;
        background: #fe1060;
    }
    .filer-control-dropdown__menu-action-btn_apply:hover {
        background: #d00146;
    }
</style>